export const basePath = '/front'
